<template>
  <div class="section-container">
    <TestimonialsHeader />

    <!-- 四列布局网格 -->
    <div class="testimonials-grid">
      <TestimonialCard v-for="item in visibleTestimonials" :key="item.name" :testimonial="item" />
    </div>

    <!-- 底部“View More / Show Less”按钮区 (仅当数据超过默认行数时显示) -->
    <div class="load-more-container" v-if="allTestimonials.length > 20">
      <button class="load-more-btn" @click="toggleExpand">
        {{ isExpanded ? 'Show Less' : 'View More' }}
        <span class="arrow" :class="{ 'arrow-up': isExpanded }">▼</span>
      </button>
    </div>
  </div>
</template>

<script>
import TestimonialCard from './TestimonialCard.vue';
import TestimonialsHeader from './TestimonialsHeader.vue';

export default {
  components: { TestimonialCard, TestimonialsHeader },
  data() {
    return {
      visibleCount: 20,
      allTestimonials: [
        { name: 'James Harrington', country: 'United States', flag: '🇺🇸', content: 'I lost over $45,000 to a fake crypto investment platform. Fraud Counsel traced every transaction and helped me file an enforcement case. Their process was thorough and professional from start to finish. I genuinely cannot thank them enough for restoring my confidence.', date: 'May 2025' },
        { name: 'Sophie Whitfield', country: 'United Kingdom', flag: '🇬🇧', content: 'After falling victim to a romance scam I was embarrassed and did not know where to turn. The team was incredibly respectful and discreet. They recovered a significant portion of my funds and kept me informed every single step of the way. Outstanding service.', date: 'Jan 2025' },
        { name: 'Michael Okonkwo', country: 'Canada', flag: '🇨🇦', content: 'The blockchain forensics team identified exactly where my Bitcoin went after the exchange hack. Their detailed report gave me everything I needed to escalate with authorities. Professional, fast, and genuinely dedicated to getting results for victims of crypto fraud.', date: 'Feb 2025' },
        { name: 'Lena Hartmann', country: 'Australia', flag: '🇦🇺', content: 'I was sceptical at first but the transparency throughout the investigation changed my mind completely. They explained every step in plain language and never made me feel like just another case number. Highly recommend to anyone who has lost crypto to fraud.', date: 'Apr 2025' },
        { name: 'Gabriela Torres', country: 'Mexico', flag: '🇲🇽', content: 'The investigation team traced my stolen funds through three different blockchains and across two continents. Every update was clear and detailed. I felt supported and informed throughout the entire process and the final outcome was beyond what I had hoped for.', date: 'Jan 2025' },
        { name: 'Ayşe Kılıç', country: 'Turkey', flag: '🇹🇷', content: 'After a fake broker took my savings I contacted several firms but Fraud Counsel was the only one that gave me a real plan with actual blockchain evidence. Their team was always available to answer my questions and the results they achieved were remarkable.', date: 'May 2025' },
        { name: 'Kenji Yamamoto', country: 'Japan', flag: '🇯🇵', content: 'I lost a significant amount of ETH through a smart contract exploit on a DeFi platform. Fraud Counsel analysed the contract, traced the stolen tokens, and provided a forensic report that supported my legal claim. A truly impressive and highly specialised team.', date: 'Apr 2025' },
        { name: 'Kwame Asante', country: 'Ghana', flag: '🇬🇭', content: 'The team recovered funds I had completely written off after a social media investment scam. They were patient, professional, and thorough in every step of the investigation. I would not hesitate to recommend Fraud Counsel to anyone who has been a victim of crypto fraud.', date: 'Mar 2025' },
        { name: 'Nikolaos Papadakis', country: 'Greece', flag: '🇬🇷', content: 'After a crypto trading mentor convinced me to move my funds to a platform he controlled I lost everything. Fraud Counsel traced the entire movement, identified the associated wallets, and compiled evidence for a legal case. Their team gave me back hope when I felt lost.', date: 'Apr 2025' },
        { name: 'Clara Murphy', country: 'Ireland', flag: '🇮🇪', content: 'A sophisticated scam posing as a regulated investment firm took a substantial amount of my crypto savings. Fraud Counsel investigated the full operation, traced the wallets, and helped me file a formal complaint with regulatory authorities. World-class service throughout.', date: 'May 2025' },
        { name: 'John Smith', country: 'USA', flag: '🇺🇸', content: 'Their expertise in tracing funds across exchanges was unmatched. I got my money back in record time. Highly professional team.', date: 'Jan 2025' },
        { name: 'Li Wei', country: 'China', flag: '🇨🇳', content: '非常专业的团队，帮我追踪到了被诈骗的以太坊。过程透明高效，值得信赖！', date: 'Feb 2025' },
        { name: 'Maria Garcia', country: 'Spain', flag: '🇪🇸', content: 'Excelente servicio. Recuperaron mis fondos después de un fraude con criptomonedas. Muy agradecido.', date: 'Mar 2025' },
        { name: 'Pierre Dubois', country: 'France', flag: '🇫🇷', content: 'Une équipe très compétente et réactive. Ils ont su retracer la blockchain et récupérer mes actifs. Je recommande vivement.', date: 'Apr 2025' },
        { name: 'Ivan Petrov', country: 'Russia', flag: '🇷🇺', content: 'Профессиональный подход к трассировке блокчейна. Спасли мои средства. Большое спасибо за работу!', date: 'May 2025' },
        { name: 'Sarah Johnson', country: 'USA', flag: '🇺🇸', content: 'They gave me peace of mind during a very stressful time. My case was handled with the utmost confidentiality and expertise.', date: 'May 2025' },
        { name: 'Ahmed Hassan', country: 'Egypt', flag: '🇪🇬', content: 'Through thorough investigation, they found the scammer and recovered a large sum of my funds. Fantastic communication throughout.', date: 'May 2025' },
        { name: 'Emma Wilson', country: 'New Zealand', flag: '🇳🇿', content: 'Their expert analysis of the smart contract was the key to my successful recovery. I cannot thank them enough.', date: 'May 2025' },
        { name: 'David Kim', country: 'South Korea', flag: '🇰🇷', content: 'Swift and professional action was taken. The forensic report was impeccable. Truly top-tier crypto recovery service.', date: 'May 2025' },
        { name: 'Anna Nowak', country: 'Poland', flag: '🇵🇱', content: 'Zespół profesjonalistów, którzy znają się na rzeczy. Odzyskałem środki dzięki ich analizie on-chain. Polecam!', date: 'May 2025' },
        { name: 'Lucas Silva', country: 'Brazil', flag: '🇧🇷', content: 'Equipe excelente, investigaram a fundo e recuperaram meus ativos digitais. Muito obrigado!', date: 'May 2025' },
        { name: 'Arjun Patel', country: 'India', flag: '🇮🇳', content: 'They tracked the stolen crypto through a complex web of transactions with pinpoint accuracy. Outstanding work.', date: 'May 2025' },
        { name: 'Sofia Rossi', country: 'Italy', flag: '🇮🇹', content: 'Servizio impeccabile e tempi rapidissimi. Finalmente ho recuperato i miei fondi grazie al loro team di esperti.', date: 'May 2025' },
        { name: 'James Smith', country: 'USA', flag: '🇺🇸', content: 'Transparency and precision from start to finish. They are true professionals in the crypto space.', date: 'May 2025' }
      ]
    };
  },
  computed: {
    visibleTestimonials() {
      return this.allTestimonials.slice(0, this.visibleCount);
    },
    isExpanded() {
      return this.visibleCount >= this.allTestimonials.length;
    }
  },
  methods: {
    toggleExpand() {
      if (this.isExpanded) {
        this.visibleCount = 20;
      } else {
        this.visibleCount = this.allTestimonials.length;
      }
    }
  }
}
</script>

<style scoped>
.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 30px;
  column-gap: 20px;

  padding: 0 5%;
}

/* 按钮容器居中 */
.load-more-container {
  display: flex;
  justify-content: center;
  padding: 40px 0 80px;
}

/* 还原图片风格的按钮（颜色淡一点，字体小一点） */
.load-more-btn {
  background-color: transparent;
  border: 1px solid #4fd1c5;
  color: #4fd1c5;
  padding: 12px 30px;
  font-size: 0.95rem;
  /* 字体小一点 */
  font-weight: bold;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-family: inherit;
}

.load-more-btn:hover {
  background-color: rgba(79, 209, 197, 0.1);
  box-shadow: 0 0 15px rgba(79, 209, 197, 0.2);
}

/* 箭头旋转 180 度动画 */
.arrow {
  display: inline-block;
  margin-left: 10px;
  transition: transform 0.3s ease;
}

.arrow.arrow-up {
  transform: rotate(180deg);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .testimonials-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .testimonials-grid {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }

  .load-more-btn {
    width: 90%;
  }
}
</style>